export const REFRESH_SESSION = 'REFRESH_SESSION';
export const DESTROY_SESSION = 'DESTROY_SESSION';
export const TAKE_VOTE_ACCESS = 'TAKE_VOTE_ACCESS';
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const SHOW_DIALOG = 'SHOW_DIALOG';
export const HIDE_DIALOG = 'HIDE_DIALOG';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION';
export const SET_PASSWORD_RESET_AFTER_LOGIN = 'SET_PASSWORD_RESET_AFTER_LOGIN';
